export default "__VITE_ASSET__Cbwdcldt__"